import { fetchEmpleados, fetchEmpleadosCount } from "../../../redux/Empleados/EmpleadosSlice";

export const loadEmpleados = (filtro) => (dispatch) => {
  
  const codigo = filtro.codigo ? filtro.codigo : 0;

  dispatch(fetchEmpleados({...filtro, codigo}));

  dispatch(
    fetchEmpleadosCount({ 
      nombre: filtro.nombre,
      apellido: filtro.apellido,
      areaOrganizacionalId: filtro.areaOrganizacionalId,
      cargoId: filtro.cargoId,
      estado: filtro.estado,
      codigo
    })
  );

};